export * from './tabs-department-modal.component'
